// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"79e2d357","363":"94f99c11","481":"94f99c11","624":"9ce421a1","787":"4aef5002","890":"9ce421a1"}[chunkId] + ".chunk.css";
};